/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROSUPPLIER", "184")


  
    
export interface API19570Item {
  
  /**  */
  type?: number;
  
  /**  */
  name?: string;
  
  /** 0:未选中1:已选中 */
  checked?: number;
  
};
    
  



  export type API19570Req = {};



export interface API19570Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** CheckedTypeDTO  */
  data?: API19570Item[];
  /**   */
  exceptionMsg?: string;
  
};


// 19570 合作模式列表

export interface IUseGetAPI19570Return {
  /** 合作模式列表: 接口请求状态 */
  isAPI19570Loading: boolean;
  /** 合作模式列表: 接口请求返回数据 */
  dataAPI19570: API19570Res;
  /**  合作模式列表: 接口数据请求方法 */
  fetchAPI19570Data:  ( config?: YWRequestConfig) => Promise<API19570Res>;
  /** 合作模式列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI19570 = ():IUseGetAPI19570Return => {
  let isMount = true;
  const [isAPI19570Loading, setIsAPI19570Loading] = useState(false);
  const [dataAPI19570, setDataAPI19570] = useState<API19570Res>({} as API19570Res);
  const requestUrl = `${basePath}/ywwl-supply-chain-admin/new/partner/list`;

  const fetchAPI19570Data = async ( config?: YWRequestConfig): Promise<API19570Res> => {
  
    if ( isMount ) {
      setIsAPI19570Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API19570Res>(`${basePath}/ywwl-supply-chain-admin/new/partner/list`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI19570(res || {} as API19570Res);
        setIsAPI19570Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI19570Loading(false);
      }
      return false as unknown as API19570Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI19570Loading,
    dataAPI19570,
    fetchAPI19570Data,
    requestUrl,
  }
}

